import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const generationColorPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.GenerationColor },
    { actions: [Actions.read], subject: Models.GenerationColors },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.GenerationColor },
    { actions: [Actions.read], subject: Models.GenerationColors },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.GenerationColor },
    { actions: [Actions.read], subject: Models.GenerationColors },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.GenerationColor },
    { actions: [Actions.read], subject: Models.GenerationColors },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
